export default __webpack_public_path__ + "static/media/time.d905bed3.svg";